/** PD: Prompt Departure
 * @see https://www.figma.com/design/3mqOpM9qqbKSvc035ejbLX/DESIGN-SYSTEM?node-id=38664-4491&t=Yu7zt9rjNQQx6AVC-4
 */
import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";

import { formatDuration } from "@signolteam/shared/units-of-measure";
import AppUtils from "@src/utils/appUtils.js";

let defaultMetadata = {
  pd_departure_delay_hours: "1.96",
  pd_hours_saved: "1.0",
  constant_pd_departure_threshold_hours: "2.5",
  constant_pd_docked_fuel_per_hour_kg: "100",
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  unit = "hr",
  metadata = defaultMetadata,
  missingDataMsg,
  bvrColour,
  isExample,
}) {
  //metadata = defaultMetadata; // TEMP
  const actual_hours = Number(metadata["pd_departure_delay_hours"]);
  const threshold_hours = Number(
    metadata["constant_pd_departure_threshold_hours"],
  );

  if (isNaN(actual_hours) || isNaN(threshold_hours)) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  const SECONDS_IN_AN_HOUR = 3600;
  const actual_seconds = actual_hours * SECONDS_IN_AN_HOUR;
  const threshold_seconds = threshold_hours * SECONDS_IN_AN_HOUR;

  const actual = actual_hours;
  const threshold = threshold_hours;

  const data = [
    {
      name: "Actual time taken",
      mobileName: "Actual",
      beforeThreshold: actual > threshold ? threshold : actual,
      afterThreshold: actual > threshold ? actual - threshold : 0,
      underThresholdColour:
        actual > threshold ? bvrColour.codes["200"] : bvrColour.codes["500"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMin = 0;
  const margin = 0.2 * actual;
  const domainMax = Math.ceil(Math.max(threshold, actual) + margin);
  const domain = [domainMin, domainMax];

  const mobileMargin = 0.05 * actual;
  const mobileDomainMax = Math.ceil(Math.max(threshold, actual) + mobileMargin);
  const mobileDomain = [domainMin, mobileDomainMax];
  const thresholdLineColour = bvrColour.codes["900"];

  return (
    <BehaviourBarGraph
      data={data}
      threshold={threshold}
      thresholdLabel={`Signol threshold${
        !isExample
          ? ` (${formatDuration(threshold_seconds, { boundaryValues: [0, actual_seconds] }).formattedValue})`
          : ""
      }`}
      mobileDomain={mobileDomain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={actual < threshold}
      unitOfMeasure={unit}
      axisLabel={`Time`}
      hideYLine={true}
      hideNum={true}
      barLabelFormatter={() =>
        formatDuration(actual_seconds, {
          boundaryValues: [0, threshold_seconds],
        }).formattedValue
      }
      ticks={
        //Most of the time the value is between 0 and 5
        AppUtils.generateTicks(0, domainMax, 1)
      }
      isExample={isExample}
    />
  );
}
